import script from "./FlowPreviewChat.vue?vue&type=script&setup=true&lang=js"
export * from "./FlowPreviewChat.vue?vue&type=script&setup=true&lang=js"

import "./FlowPreviewChat.vue?vue&type=style&index=0&id=20419407&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20419407"]])

export default __exports__